import { render, staticRenderFns } from "./CobSearchCustomer.vue?vue&type=template&id=24a87108&"
import script from "./CobSearchCustomer.vue?vue&type=script&lang=js&"
export * from "./CobSearchCustomer.vue?vue&type=script&lang=js&"
import style0 from "./CobSearchCustomer.vue?vue&type=style&index=0&id=24a87108&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports